/* @jsx jsx */

import { jsx, Box } from 'theme-ui'

import PropTypes from 'prop-types'
import Text from '~/components/IntlComponents/Text'

const StickerTag = ({
  title,
  position = 'top-left',
  stroke,
  fill,
  size = { width: 80, height: 82 },
  style = { top: '-36px', left: ['10px', '10px', '50px'] },
  textSize = title?.split(' ')?.[0]?.length > 4 ? 12 : 14,
}) => {
  function getPositionOnItem(position) {
    switch (position) {
      case 'top-right':
        style.right = 0
        style.transform = 'translateX(30%)'
        break
      case 'bottom-left':
        style.top = null
        style.bottom = '56px'
        break
      case 'bottom-right':
        style.top = null
        style.bottom = '56px'
        style.left = null
        style.right = 0
        style.transform = 'translateX(30%)'
        break
      case 'custom':
        break
      default:
        break
    }
    return style
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        ...getPositionOnItem(position),
        maxWidth: size.width,
        maxHeight: size.height,
        zIndex: 3,
      }}
    >
      <svg
        width="80"
        height="82"
        viewBox="0 0 80 82"
        xmlns="http://www.w3.org/2000/svg"
        sx={{ width: size.width, height: size.height }}
      >
        <path
          d="M73.1696 24.8154L73.2179 24.9372L73.2961 25.0423C73.9409 25.9098 74.8452 27.0583 75.999 28C76.637 28.6439 77.2762 29.2934 77.8127 29.9822C78.3566 30.6807 78.7463 31.3604 78.9153 32.0316C79.2111 33.3949 78.7457 34.6052 78.1638 36.1189C78.0769 36.3449 77.9874 36.5776 77.8974 36.8187C77.2323 38.1711 76.7449 39.6117 76.7449 41.1082C76.7449 42.592 77.227 44.0254 77.662 45.1261C77.7963 45.5311 77.9274 45.8961 78.0511 46.2405C78.251 46.7971 78.4316 47.3 78.5753 47.8316C78.7957 48.647 78.8607 49.3235 78.704 49.9559L78.7009 49.9685L78.6981 49.9812C78.3458 51.5809 77.2961 52.6931 75.8153 53.975L75.8069 53.9817C75.2858 54.4024 74.7136 54.8642 74.2189 55.3633C73.7157 55.871 73.2389 56.4689 72.9552 57.1846C72.4747 58.3966 72.2478 59.8047 72.2419 61.3834C72.0221 63.158 71.8136 64.8065 70.9238 66.0634C70.5298 66.6199 69.9555 67.0139 69.2059 67.3555C68.7011 67.5855 68.2039 67.7584 67.6643 67.946C67.3607 68.0516 67.0437 68.1619 66.7044 68.2896C65.2405 68.7125 63.7911 69.1849 62.7726 69.9557L62.7161 69.9984L62.6663 70.0487C61.7116 71.012 61.0191 72.1841 60.3714 73.4836C60.1629 73.7809 59.9611 74.0863 59.7684 74.378C59.7179 74.4544 59.6681 74.5298 59.6189 74.6039C59.3628 74.9899 59.1177 75.3504 58.8591 75.6859C58.3439 76.3543 57.8087 76.8771 57.1352 77.2169L57.1104 77.2294L57.0864 77.2433C56.564 77.5444 55.9194 77.649 55.0934 77.6245C54.5031 77.607 53.9124 77.5309 53.2618 77.447C52.9748 77.41 52.6763 77.3715 52.361 77.3359C51.1193 77.1274 49.4426 76.8723 48.166 77.1299C46.877 77.39 45.6697 78.141 44.567 79.0251C44.437 79.1072 44.31 79.1878 44.1857 79.2668C42.5978 80.2749 41.4482 81.0047 40 81.0047C38.4229 81.0047 36.9426 80.1151 35.4355 79.029L35.4032 79.0056L35.3691 78.985C35.119 78.8336 34.8661 78.6679 34.5953 78.4903L34.5883 78.4856C34.325 78.313 34.0443 78.1289 33.7608 77.9573C33.199 77.6172 32.5433 77.273 31.834 77.1299C30.6597 76.8929 29.3052 77.0919 27.9981 77.2838C27.8796 77.3012 27.7615 77.3186 27.6439 77.3355C27.397 77.3667 27.1583 77.4002 26.9248 77.4328C26.2859 77.5222 25.6862 77.6062 25.0674 77.6245C24.2509 77.6487 23.5222 77.5485 22.8648 77.2169L22.8179 77.1932L22.7687 77.1746C21.4538 76.6771 20.5263 75.295 19.6629 73.5528L19.6521 73.5309C19.3381 72.8972 18.9998 72.2145 18.6277 71.6081C18.2549 71.0005 17.8023 70.3907 17.2274 69.9557L17.1863 69.9246L17.1422 69.8979C15.9756 69.1916 14.6012 68.7295 13.3531 68.3098L13.3161 68.2973C12.969 68.1663 12.6454 68.0537 12.3357 67.946C11.7961 67.7584 11.2989 67.5855 10.7941 67.3555C10.0445 67.0139 9.47021 66.6199 9.07625 66.0634L9.02872 65.9963L8.97083 65.9379C8.5134 65.4763 8.25168 64.8721 8.08534 64.0808C7.96148 63.4917 7.90386 62.8851 7.83941 62.2066C7.81312 61.9299 7.7857 61.6413 7.75219 61.337L7.74925 61.3102L7.74487 61.2837C7.69558 60.9853 7.65791 60.6701 7.61719 60.3277L7.61589 60.3168C7.57657 59.9861 7.53413 59.6293 7.47683 59.2824C7.3652 58.6066 7.17577 57.8088 6.70393 57.174C6.05914 56.3066 5.1548 55.158 4.00103 54.2163C3.36304 53.5725 2.72376 52.923 2.18733 52.2341C1.64336 51.5356 1.25366 50.8559 1.08465 50.1847C0.788948 48.8214 1.25429 47.6111 1.83624 46.0975C1.92314 45.8715 2.01264 45.6387 2.10259 45.3976C2.76767 44.0453 3.25508 42.6046 3.25508 41.1082C3.25508 39.8483 2.77944 38.2109 2.33807 37.0905C2.20378 36.6854 2.07267 36.3204 1.94893 35.9758C1.74904 35.4193 1.5684 34.9163 1.42472 34.3847C1.20433 33.5694 1.13929 32.8928 1.29597 32.2605L1.29909 32.2479L1.30188 32.2352C1.65423 30.6354 2.70391 29.5232 4.18475 28.2414L4.19319 28.2346C4.71429 27.814 5.28643 27.3522 5.78113 26.853C6.28426 26.3454 6.76107 25.7475 7.04482 25.0317C7.53161 23.8038 7.75817 22.3746 7.75817 20.7704C7.75817 18.8267 7.99099 17.2162 8.81263 16.2168C9.88871 14.9533 11.3447 14.3685 13.1992 13.9527L13.2497 13.9414L13.2987 13.9249L13.3531 13.9066C14.6012 13.4869 15.9755 13.0248 17.1422 12.3185L17.2473 12.2549L17.3337 12.1677C18.3054 11.1873 19.0053 9.99062 19.6629 8.66357C20.473 7.02884 21.4368 5.69467 22.9298 4.74749C23.4493 4.45341 24.0891 4.35122 24.9065 4.37548C25.4969 4.393 26.0876 4.46915 26.7383 4.55303C27.0252 4.59002 27.3238 4.62851 27.6391 4.66414C28.8808 4.87258 30.5574 5.12771 31.834 4.8701C33.123 4.60998 34.3303 3.85903 35.433 2.97487C35.563 2.89278 35.69 2.81217 35.8143 2.73327C37.4022 1.72512 38.5518 0.99531 40 0.99531C41.5694 0.99531 43.043 1.87629 44.5425 2.95525C45.0643 3.37645 45.6319 3.83456 46.2088 4.21289C46.7917 4.59517 47.451 4.94218 48.166 5.08646C49.4588 5.34734 51.1172 5.0874 52.638 4.65586C52.861 4.62716 53.0775 4.59686 53.2896 4.56717C53.9285 4.47777 54.5282 4.39384 55.1471 4.37548C55.9635 4.35125 56.6923 4.45145 57.3496 4.78309L57.3966 4.80676L57.4457 4.82536C58.7606 5.32288 59.6881 6.705 60.5515 8.44722L60.5623 8.46899C60.8763 9.10271 61.2146 9.78544 61.5867 10.3919C61.9595 10.9995 62.4121 11.6093 62.987 12.0443L63.0281 12.0754L63.0722 12.1021C64.2389 12.8084 65.6133 13.2706 66.8614 13.6903L66.8983 13.7027C67.2454 13.8337 67.569 13.9462 67.8787 14.0539C68.4183 14.2416 68.9155 14.4145 69.4203 14.6445C70.1699 14.9861 70.7442 15.3801 71.1382 15.9366L71.1857 16.0037L71.2436 16.0621C71.701 16.5236 71.9628 17.1279 72.1291 17.9192C72.253 18.5083 72.3106 19.1149 72.375 19.7934C72.3998 20.0537 72.4255 20.3246 72.4564 20.6091C72.4615 22.1909 72.6884 23.6015 73.1696 24.8154Z"
          fill={fill}
          stroke={stroke}
          strokeWidth="1.99062"
        />
      </svg>
      <Text
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '100%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          fontSize: textSize,
          lineHeight: 1,
          color: stroke,
          fontFamily: 'secondary',
        }}
      >
        {title}
      </Text>
    </Box>
  )
}

export default StickerTag

StickerTag.propTypes = {
  position: PropTypes.oneOf([
    'top-left',
    'top-right',
    'bottom-left',
    'bottom-right',
  ]),
  title: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
}
